import React from "react";
import sidebar from "../../utils/sidebar";
import LogoImg from "../../assets/img/logo.svg";

import SidebarSubMenu from "./SidebarSubMenu";
import { useStore } from "../../store/SideStore";
import useLogout from "../../hooks/useLogout";
import useGetApi from "../../hooks/useGetApi";
import { NavLink, useLocation } from "react-router-dom";
import { IoLogOutOutline, IoMenu } from "react-icons/io5";

export default function HamburgerMenu({ handleOpenHamburgerMenu, isHamburgerMenuOpen }) {
    const location = useLocation();
    const { logout } = useLogout();
    const isOpen = useStore((state) => state.isOpen);
    const { allData } = useGetApi("activities/admin/orders/");

    return (
        <div
            className={`w-full h-[100vh] fixed left-0 top-0 bg-[rgba(0,0,0,0.5)] z-10 ${
                isHamburgerMenuOpen ? "block" : "hidden"
            }`}
            onClick={handleOpenHamburgerMenu}
        >
            <div
                className={`bg-gray-800 absolute w-[40%] flex flex-col justify-between  h-[100vh] z-[20] max-[768px]:block max-[540px]:w-[70%] max-[360px]:w-[85%] overflow-hidden pt-[20px] ssm:w-[60%] 2xs:w-full
                     ${
                         isHamburgerMenuOpen
                             ? "left-0 transition-all ease-in duration-500"
                             : "left-[-500px] transition-all ease-in duration-500"
                     }`}
            >
                {/* <button
                    className="absolute top-4 right-4 bg-red-500 text-white rounded p-2"
                    onClick={handleOpenHamburgerMenu}
                >
                    Close
                </button>
                <p>helloooo</p> */}

                {/* Hamburger menu logo */}
                <div className="w-[100px] mb-[20px]">
                    <img src={LogoImg} alt="logo icon" className="w-full block" />
                </div>

                {/* Navigation */}
                <nav className="flex flex-col flex-grow">
                    <ul className="space-y-1">
                        {sidebar.map((route) =>
                            route.routes ? (
                                <SidebarSubMenu route={route} key={route.name} />
                            ) : (
                                <li key={route.name}>
                                    <NavLink
                                        to={route.path}
                                        target={route?.outside ? "_blank" : "_self"}
                                        className={`flex items-center px-4 py-2 text-sm font-semibold hover:bg-gray-600 ${
                                            location.pathname === route.path
                                                ? "bg-gray-700 text-emerald-500"
                                                : "text-white hover:bg-gray-700"
                                        }`}
                                    >
                                        {route.icon && (
                                            <route.icon
                                                className="w-5 h-5 mr-3"
                                                aria-hidden="true"
                                            />
                                        )}
                                        <span className={`${isOpen ? "block" : "hidden"}`}>
                                            {route.name}
                                            {route.name === "Orders" &&
                                                allData?.pending_orders > 0 && (
                                                    <span className="ml-2 inline-flex items-center justify-center px-2 py-0.5 text-xs font-medium text-white bg-red-500 rounded-full">
                                                        {allData.pending_orders}
                                                    </span>
                                                )}
                                        </span>
                                    </NavLink>
                                </li>
                            )
                        )}
                    </ul>
                </nav>

                {/* Logout Button */}
                <div className="mt-auto px-4 pb-4 mlg:w-max">
                    <button
                        onClick={logout}
                        className="w-full flex items-center justify-center bg-white text-black py-2 px-4 rounded-lg shadow-md hover:bg-gray-200 mlg:rounded-[4px]"
                    >
                        <IoLogOutOutline className="mr-2 text-lg" />
                        <span className={`${isOpen ? "block" : "hidden"}`}>Log Out</span>
                    </button>
                </div>
            </div>
        </div>
    );
}
